import $ from "jquery";
import "jquery-validation/dist/jquery.validate";

$(document).ready(function () {
  // Forms - jQuery Validate - Set defaults
  $.validator.setDefaults({
    errorElement: "div",
    errorPlacement: function (error, element) {
      error.addClass("invalid-feedback");

      element.parents(".form-group").addClass("has-feedback");

      if (
        element.prop("type") === "checkbox" ||
        element.prop("type") === "radio"
      ) {
        error.insertAfter(element.parents(".form-check"));
      } else {
        error.insertAfter(element);
      }
    },
    highlight: function (element) {
      $(element)
        .parents(".form-group")
        .addClass("has-error")
        .removeClass("has-success");
    },
    unhighlight: function (element) {
      $(element)
        .parents(".form-group")
        .addClass("has-success")
        .removeClass("has-error");
    },
  });
});
